import {Stack, TextField, Typography} from '@mui/material';
import React from 'react';
import {Controller, useFormContext} from 'react-hook-form';

import {translations} from 'presentation/translations-new';
import {useRefundRequest} from 'presentation/pages/private/refund/hooks';
import {CouncilTypeSelect} from '../../../CouncilTypeSelect';
import {StateAutoComplete} from '../../../StateAutoComplete';
import {CouncilFieldsProps} from './types';

const {
	councilType: councilTypeText,
	state: stateText,
	councilNumber,
	councilNumberPlaceholder,
} = translations['pt-br'].privateFlow.refund.receiptRegistrationPage.providerData;

const {requiredField} = translations['pt-br'].commons;

export const CouncilFields = ({handleReset, searchInProvider}: CouncilFieldsProps) => {
	const {control, setValue} = useFormContext();
	const {handleUpdateFormAtoms, formAtoms} = useRefundRequest();

	function handleOnFocus() {
		if (!searchInProvider) {
			setValue('doctorNotFound', false);
			setValue('professionalDocument', '');
			handleUpdateFormAtoms.providerData({
				...formAtoms.providerDataForm,
				doctorNotFound: false,
				professionalDocument: '',
			});
		}
		setValue('professionalName', '');
		setValue('professionalNotFound', false);
		handleUpdateFormAtoms.providerData({
			...formAtoms.providerDataForm,
			professionalNotFound: false,
			professionalName: '',
		});

		if (handleReset) {
			handleReset();
		}
	}

	return (
		<Stack gap={2}>
			<Stack gap={1}>
				<Typography color="primary" fontWeight={600}>
					{councilTypeText}
				</Typography>
				<CouncilTypeSelect name="councilAcronym" />
			</Stack>

			<Stack gap={1}>
				<Typography color="primary" fontWeight={600}>
					{stateText}
				</Typography>
				<StateAutoComplete name="councilState" />
			</Stack>

			<Stack gap={1}>
				<Typography color="primary" fontWeight={600}>
					{councilNumber}
				</Typography>
				<Controller
					control={control}
					name="councilNumber"
					render={({field: {value, onChange}, fieldState: {invalid}}) => (
						<TextField
							value={value || ''}
							error={invalid}
							onChange={event => {
								const filteredValue = event.target.value.replace(/\D/g, '');
								onChange(filteredValue);
							}}
							slotProps={{htmlInput: {inputMode: 'numeric'}}}
							placeholder={councilNumberPlaceholder}
							label={councilNumberPlaceholder}
							onFocus={handleOnFocus}
							helperText={
								invalid ? (
									<Typography component="span" variant="helperText" color="error">
										{requiredField}
									</Typography>
								) : null
							}
						/>
					)}
				/>
			</Stack>
		</Stack>
	);
};
